import React from 'react';
import '../ServicesStyles/ServicesMain.css';

const ServiceMain = () => {
  return (
    <div className="services-hero-container">
      <div className="services-hero-shapes">
        <div className="sh-shape sh-shape-1"></div>
        <div className="sh-shape sh-shape-2"></div>
      </div>
      <div className="services-hero-content">
        <span className="services-hero-badge">Our Services</span>
        <h1 className="services-hero-heading">
          Where innovation meets precision to
          <span className="services-hero-accent"> elevate your business.</span>
        </h1>
        <p className="services-hero-quote">
          "Empowering businesses through innovative technology and strategic solutions."
        </p>
        <div className="services-hero-tags">
          <span><i className="bi bi-display"></i> Web Development</span>
          <span><i className="bi bi-phone"></i> Mobile Apps</span>
          <span><i className="bi bi-receipt"></i> Billing</span>
          <span><i className="bi bi-headset"></i> IT Support</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceMain;
